import React from 'react'
import Button from "./Button"
import "./VolumeButton.css"
import { useLang } from '../../../language/LanguageProvider.jsx'

const VolumeButton = ({enabled, volume, onChangeInput, onClick}) => {
    const { t } = useLang();
    return (
        <div className="volume-container">
            <Button enabled={enabled} iconOn={"fas fa-volume-up"} iconOff={"fas fa-volume-mute"} textOn={t('player.mute')} textOff={t('player.unmute')} onClick={onClick}/>
            <input 
                value={volume} 
                type={'range'} 
                min={0}
                max={100}
                step={5}
                onChange={onChangeInput}
                >
            </input>
        </div>
    )
}

export default VolumeButton
